import { useState } from "react";
import { useI18n } from "../i18n.js";
import { PANEL } from "./text.js";

/**
 * "Insert example" for the persona and the response instructions. An empty field is filled at once; a field that already has
 * text asks first, so nothing the owner wrote is lost by a click.
 */
export function ExampleButtons({ field, value, onPick }: { field: "persona" | "responseInstructions"; value: string; onPick: (text: string) => void }) {
  const { t, lang } = useI18n();
  const [pending, setPending] = useState<string | null>(null);
  const choose = (text: string) => {
    if (value.trim() === "") onPick(text);
    else setPending(text);
  };
  return (
    <div className="row examples" role="group" aria-label={t("example.group")}>
      <span className="hint">{t("example.label")}</span>
      <button type="button" className="btn secondary" onClick={() => choose(PANEL.examples.general[field][lang])}>{t("example.general")}</button>
      <button type="button" className="btn secondary" onClick={() => choose(PANEL.examples.service[field][lang])}>{t("example.service")}</button>
      {pending !== null && (
        <span role="alert" className="row">
          <span>{t("example.replace")}</span>
          <button type="button" className="btn secondary" onClick={() => { onPick(pending); setPending(null); }}>{t("example.yes")}</button>
          <button type="button" className="btn secondary" onClick={() => setPending(null)}>{t("example.no")}</button>
        </span>
      )}
    </div>
  );
}
